<ct-lib-modal class="tfa-required-modal" [small]="true" [hideHeader]="true" [hideFooter]="true" [closeable]="false" #tfaRequiredModal>
  <img src="./assets/animations/line-arts/tfa/app_enter.svg" alt="">
  <div class="text-center">
    <h4>{{'company-tool.snippets.tfa.block-modal.title' | transloco}}</h4>
    <p [innerHTML]="'company-tool.snippets.tfa.block-modal.info-time-left' | transloco: {
      tfaRequiredRemainingDays
    }"><p>
    <app-button [routerLink]="['/settings', 'profile', 'security']" (click)="tfaRequiredModal.close()">{{'company-tool.snippets.tfa.block-modal.to-security-settings' | transloco}}</app-button>
    <a (click)="tfaRequiredModal.close()">{{'company-tool.snippets.tfa.block-modal.skip' | transloco}}</a>
  </div>
</ct-lib-modal>

<ct-lib-modal class="tfa-required-modal" [closeable]="false" [small]="true" [hideHeader]="true" [hideFooter]="true" #tfaRequiredBlockedModal>
  <img src="./assets/animations/line-arts/tfa/app_enter.svg" alt="">
  <div class="text-center">
    <h4>{{'company-tool.snippets.tfa.block-modal.title' | transloco}}</h4>
    <p [innerHTML]="'company-tool.snippets.tfa.block-modal.info-no-time-left' | transloco: {
      tfaRequiredSinceDays
    }"><p>
    <app-button (click)="triggerAddMethodModal.emit()">{{'company-tool.snippets.tfa.block-modal.add-method' | transloco}}</app-button>
    <a (click)="logout();">{{'company-tool.snippets.tfa.block-modal.logout' | transloco}}</a>
  </div>
</ct-lib-modal>